import { mutationSuccessListeners, reactQueryUtils } from "@lib/react-query";
import { useEffect } from "react";
import { onboardingKeys } from "./onboarding.keys";

const SETTLE_MS = 800;

/**
 * Refetches the onboarding state shortly after any mutation succeeds, so
 * derived tasks (profile, share, folder, brand, invite) tick without a reload.
 * Registered only while the platform shell is mounted and `enabled` (a cohort
 * user with tasks left); invalidation refetches active queries only, so the
 * editor never pays for it.
 */
export const useRefreshOnboardingOnMutations = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;
    let timer: number | undefined;
    const listener = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        reactQueryUtils.invalidateQueries([...onboardingKeys.state]);
      }, SETTLE_MS);
    };
    mutationSuccessListeners.add(listener);
    return () => {
      mutationSuccessListeners.delete(listener);
      window.clearTimeout(timer);
    };
  }, [enabled]);
};
